import { isRecord } from '@cli-utils/shared.js'
import { collectSlotAreaErrors } from './collect-slot-area-errors.js'

export function collectSlotLayoutErrors(value: unknown, path: string, errors: string[]): void {
  if (!isRecord(value)) {
    errors.push(`${path} must be an object with "main" and/or "sidebar" field groups.`)
    return
  }

  const validKeys = new Set(['main', 'sidebar'])
  for (const key of Object.keys(value)) {
    if (!validKeys.has(key)) {
      errors.push(`${path} has unsupported key "${key}". Expected "main" or "sidebar".`)
    }
  }

  const areas = [
    ['main', value.main],
    ['sidebar', value.sidebar]
  ] as const
  let hasArea = false

  for (const [name, area] of areas) {
    if (area === undefined) continue
    hasArea = true
    collectSlotAreaErrors(area, `${path}.${name}`, errors)
  }

  if (!hasArea) {
    errors.push(`${path} must define at least one of "main" or "sidebar".`)
  }
}
